var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"content"},[_c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_c('PageInfo',{staticClass:"mt50",attrs:{"info":_vm.infoText||_vm.defaultDesc}})],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }